<div>
  <div>
    <form [formGroup]="form">
      <kendo-gridlayout [rows]="[{height:38},{height:38},{height:100},{height:38}]"
                        [cols]="[{width:75},{width:350}]"
                        [gap]="{rows:0,cols:40}">

        <kendo-gridlayout-item [row]="1" [col]="1" [colSpan]="1">
          <kendo-label>Name *</kendo-label>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [row]="1" [col]="2" [colSpan]="1">
          <kendo-textbox formControlName="name"></kendo-textbox>
        </kendo-gridlayout-item>

        <kendo-gridlayout-item [row]="2" [col]="1" [colSpan]="1">
          <kendo-label>Description</kendo-label>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [row]="2" [col]="2" [colSpan]="1">
          <kendo-textbox formControlName="description"></kendo-textbox>
        </kendo-gridlayout-item>

        @if (isNew) {
        <kendo-gridlayout-item [row]="3" [col]="1" [colSpan]="1">
          <kendo-label>File</kendo-label>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [row]="3" [col]="2" [colSpan]="1">
          <kendo-fileselect formControlName="file"
                            [restrictions]="myRestrictions"
                            (select)="onSelect($event)"
                            [multiple]="false"></kendo-fileselect>
        </kendo-gridlayout-item>
        }
      </kendo-gridlayout>
    </form>
  </div>
  <div class="submitSection">
    <button kendoButton class="btnSave" [disabled]="!form.valid" (click)="save()" style="float:right;margin-top:25px" themeColor="tertiary">Save</button>
  </div>
</div>
